export const reportConst ={
    reports: "/reports",
    recurringBenefits: "/recurring-benefits",
    recurringLineTypes: "/recurring-line-types",
    summaryReport: "/summary-report",
    salaryAccountPayment: "/salary-account-payment"
}